import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ItemPitch from './ItemPitch';
import PitchSVG from './PitchSVG';

const Content = styled.div`
    position: relative;
    height: 789px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    padding: 9px 0;
    overflow: hidden;
    box-sizing: border-box;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${({ type }) => (type === 'grid' ? 'center' : 'space-around')};
    padding: 0 20px;
    margin-bottom: 13px;

    > div {
        margin: 0 9px;
    }
`;

const Pitch = styled.div`
    svg {
        position: absolute;
        top: 145px;
        left: 0;
        z-index: -1;
    }
`;

function ParticipantLineUp({ lineupType = '', lineupTemplate = '' }) {
    lineupTemplate = lineupTemplate.split('-').map(item => parseInt(item, 10));

    return (
        <Content>
            {lineupTemplate.map((row, indexRow) => (
                <Row key={Math.random() + Date.now() + row} type={lineupType}>
                    {Array.from({ length: row }, (_, i) => i).map(indexLine => (
                        <ItemPitch key={Math.random() + Date.now()} position={`${indexRow + 1}${indexLine + 1}`} />
                    ))}
                </Row>
            ))}
            {lineupType === 'lineup' && (
                <Pitch>
                    <PitchSVG />
                </Pitch>
            )}
        </Content>
    );
}

ParticipantLineUp.propTypes = {
    // From connect
    lineupType: PropTypes.string.isRequired,
    lineupTemplate: PropTypes.string.isRequired
};

export default connect(({ makerToolPage }) => ({
    lineupType: makerToolPage.lineupType,
    lineupTemplate: makerToolPage.lineupTemplate
}))(ParticipantLineUp);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/ParticipantLineUp.js
 **/